import { thunk } from 'easy-peasy';

import ApiError from '~/utils/error/ApiError';
import api from '~/services/api';
import { IThunkGetMedicaidPlan } from '../types';

const onGetMedicaidPlan: IThunkGetMedicaidPlan = thunk(async ({ setMedicaidPlan }, requestInfo) => {
  setMedicaidPlan(null);
  try {
    const { data } = await api.medicaidPlan.getMedicaidPlan(requestInfo);
    const plan = data || null;
    setMedicaidPlan(plan);
    return plan;
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) return null;
    throw e;
  }
});

export default onGetMedicaidPlan;
